import React from 'react'

export const LogoProviV3 = () => (
  <svg width="1500" height="500" viewBox="0 0 1500 500" fill="#006eab" xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        className="cls-2"
        d="m181.06,324.87v-39.76h23.61c11.8,0,21.75-3.88,29.82-11.65,8.08-7.77,12.11-17.55,12.11-29.36s-3.99-22.26-11.96-30.75c-7.97-8.49-17.66-12.74-29.05-12.74s-21.08,4.4-29.05,13.2c-7.97,8.8-11.96,19.31-11.96,31.53v150.66h-41.01v-150.66c0-23.61,7.71-43.59,23.14-59.95,15.43-16.36,35.05-24.54,58.87-24.54s43.59,8.18,59.33,24.54c15.11,15.95,22.68,35.52,22.68,58.71s-7.46,41.68-22.37,57.31c-14.91,15.64-33.45,23.45-55.61,23.45h-28.58Z"
      />
      <path
        className="cls-2"
        d="m314.01,232.29c0-20.71,6.63-37.79,19.88-51.26,13.25-13.46,30.65-20.19,52.19-20.19s39.45,6.63,52.5,19.88c12.43,13.05,18.64,30.24,18.64,51.57v7.14h-41.01v-8.08c0-20.29-10.05-30.44-30.13-30.44-9.12,0-16.57,2.85-22.37,8.54-5.8,5.7-8.7,13-8.7,21.9v93.51h-41.01v-92.57Z"
      />
      <path
        className="cls-2"
        d="m526.5,147.49h-41.32v-22.99c0-5.8,2.02-10.66,6.06-14.6,4.04-3.93,8.96-5.9,14.76-5.9s10.41,1.97,14.44,5.9c4.04,3.94,6.06,8.8,6.06,14.6v22.99Zm0,17.4v159.98h-41.01v-159.98h41.01Z"
      />
      <path
        className="cls-2"
        d="m563.15,232.29c0-20.71,6.63-37.79,19.88-51.26,13.25-13.46,30.65-20.19,52.19-20.19s39.45,6.63,52.5,19.88c12.43,13.05,18.64,30.24,18.64,51.57v92.57h-41.01v-93.51c0-20.29-10.05-30.44-30.13-30.44-9.12,0-16.57,2.85-22.37,8.54-5.8,5.7-8.7,13-8.7,21.9v93.51h-41.01v-92.57Z"
      />
      <path
        className="cls-2"
        d="m812.91,324.87c-23.82,0-43.08-7.66-57.78-22.99-14.71-15.32-22.06-34.38-22.06-57.16s7.35-41.78,22.06-57c14.7-15.22,33.96-22.83,57.78-22.83h32v39.45h-28.58c-12.63,0-22.83,3.83-30.6,11.49-7.77,7.66-11.65,17.29-11.65,28.89s3.88,21.23,11.65,28.89c7.77,7.66,17.97,11.49,30.6,11.49h28.58v39.76h-32Z"
      />
      <path
        className="cls-2"
        d="m915.42,147.49h-41.32v-22.99c0-5.8,2.02-10.66,6.06-14.6,4.04-3.93,8.96-5.9,14.76-5.9s10.41,1.97,14.44,5.9c4.04,3.94,6.06,8.8,6.06,14.6v22.99Zm0,17.4v159.98h-41.01v-159.98h41.01Z"
      />
      <path
        className="cls-2"
        d="m1006.75,324.87v-39.76h23.61c11.8,0,21.75-3.88,29.82-11.65,8.08-7.77,12.11-17.55,12.11-29.36s-3.99-22.26-11.96-30.75c-7.97-8.49-17.66-12.74-29.05-12.74s-21.08,4.4-29.05,13.2c-7.97,8.8-11.96,19.31-11.96,31.53v150.66h-41.01v-150.66c0-23.61,7.71-43.59,23.14-59.95,15.43-16.36,35.05-24.54,58.87-24.54s43.59,8.18,59.33,24.54c15.11,15.95,22.68,35.52,22.68,58.71s-7.46,41.68-22.37,57.31c-14.91,15.64-33.45,23.45-55.61,23.45h-28.58Z"
      />
      <path
        className="cls-2"
        d="m1183.19,147.49h-41.32v-22.99c0-5.8,2.02-10.66,6.06-14.6,4.04-3.93,8.96-5.9,14.76-5.9s10.41,1.97,14.44,5.9c4.04,3.94,6.06,8.8,6.06,14.6v22.99Zm0,17.4v159.98h-41.01v-159.98h41.01Z"
      />
      <path
        className="cls-2"
        d="m1318.94,324.87h-28.58c-22.16,0-40.75-7.82-55.76-23.45-15.02-15.63-22.52-34.74-22.52-57.31s7.77-42.87,23.3-59.02c15.53-16.15,35.21-24.23,59.02-24.23s43.44,8.18,58.87,24.54c15.43,16.36,23.14,36.35,23.14,59.95v79.53h-41.01v-79.53c0-12.22-3.99-22.73-11.96-31.53-7.97-8.8-17.66-13.2-29.04-13.2s-21.08,4.25-29.05,12.74c-7.97,8.49-11.96,18.75-11.96,30.75s4.04,21.59,12.12,29.36c8.08,7.77,18.02,11.65,29.82,11.65h23.61v39.76Z"
      />
    </g>
  </svg>
)
